
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

import dayjs from 'dayjs'

export default {
  name: 'SearchOnlyPeriod',
  props: {
      initStartDate: {
          type: String,
          defalut : null
      },
      initEndDate: {
          type: String,
          defalut : null
      }
  },
  data() {
      return {
          startDate: '',
          endDate: '',
      }
  },
  watch: {
      startDate() {
          this.ToggleRange()
          this.sendData()
      },
      endDate() {
          this.ToggleRange()
          this.sendData()
      },
  },

  updated() {
      this.ToggleRange()
  },
  beforeDestroy() {
      this.CLEAR_STORE()
  },
  created() {
      /* 
          220602 meej date 설정 추가
       */
      if(this.initStartDate != null){
          this.startDate = new Date (this.initStartDate)
      }
      if(this.initEndDate != null){
          this.endDate = new Date (this.initEndDate)
      }
  },

  methods: {
      ...mapActions('search', ['GET_SEARCH_INFO']),
      ...mapActions('modal', ['SHOW_ALERT', 'HIDE_MODAL']),
      ...mapMutations('search', ['CLEAR_STORE']),
      ...mapMutations('paging', ['RESET_STORE']),

      // 입력받은 값으로 검색
      sendData() {
          /* 
              220318 meej reset paging 추가, 날짜 체크 조건 수정
          */
          this.RESET_STORE()
          let startDt = ''
          let endDt = ''
          let isFutureSearch = ''
          
          if(this.startDate !== '' && this.startDate != null){
              startDt = dayjs(this.startDate).format('YYYYMMDD')
              if(this.checkDate(startDt)){
                  this.startDate = ''
                  return
              }
          }
          if(this.endDate !== '' && this.endDate != null){
              endDt = dayjs(this.endDate).format('YYYYMMDD')
              if(this.checkDate(endDt)){
                  this.endDate = ''   
                  return
              }
          }

          if(startDt !== '' && endDt !== ''){
              isFutureSearch = endDt - startDt < 0
              if (isFutureSearch) {
                  this.SHOW_ALERT({
                      content: '시작날짜가 종료날자 보다 빠를 수 없습니다.',
                  })
                  this.startDate = ''
                  this.endDate = '' 
                  return
              }
          }

          console.log('test: ', startDt, endDt); 
          console.log('isFutureSearch=', isFutureSearch)

          this.GET_SEARCH_INFO({
              startDate : startDt,
              endDate : endDt,
          })
      },

      /* 
          220317 meej 날짜 체크 method 추가 : 오늘날짜와 비교
      */
      checkDate(val){
          let check = false
          const today = new Date();
          const year = today.getFullYear();
          const month = ('0' + (today.getMonth() + 1)).slice(-2);
          const day = ('0' + today.getDate()).slice(-2);
          const dateString = year + month + day;   

          if(dateString < val) {    
              this.SHOW_ALERT({ content: '선택일자가 현재일자보다 클 수 없습니다.' })             
              check = true
          } 
          return check;
      },

      weekCal(index) {
          const today = new Date()
          const day = new Date(today).getDate()
          let delta

          // 시간데이터 삭제
          this.endDate = new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getDate()
          )

          switch (index) {
            case 0:
                  delta = 3
                  break
              case 1:
                  delta = 7
                  break
              case 2:
                  delta = 14
                  break
              case 3:
                  delta = 21
                  break
              case 4:
                  delta = 30
                  break
              case 5:
                  delta = 90
                  break
              case 6:
                  delta = 180
                  break
              case 7:
                  delta = 365
                  break
              case 8:
                  delta = 730
                  break
              default:
                  this.startDate = ''
                  this.endDate = ''
                  break
          }

          if (this.endDate !== '') {
              today.setDate(day - delta)
              // 시간데이터 삭제
              this.startDate = new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  today.getDate()
              )
          }
      },

      ToggleRange() {
          const ref = this.$refs.items

          const today = new Date()

          for (let i = 0; i < ref.length; i++) {
              ref[i].classList.remove('clicked')
          }

          const oneDay = 24 * 60 * 60 * 1000
          const diffDays = Math.round(
              Math.abs((this.startDate - this.endDate) / oneDay)
          )

          // 끝나는 날짜가 오늘날짜로 고정
          if (
              diffDays !== 0 &&
              today.toDateString() !== new Date(this.endDate).toDateString()
          ) {
              return
          }

          // 시작날짜, 끝날짜 같은날짜 선택 시, 토글방지를 위한 조건문
          if (this.startDate === this.endDate) return

          switch (diffDays) {
              // 220602 meej 불필요한 코드, 주석처리
              // case 0:
              //     ref[5].classList.add('clicked')
              //     break
              case 3:
                  ref[0].classList.add('clicked')
                  break
              case 7:
                  ref[1].classList.add('clicked')
                  break
              case 14:
                  ref[2].classList.add('clicked')
                  break
              case 21:
                  ref[3].classList.add('clicked')
                  break
              case 30:
                  ref[4].classList.add('clicked')
                  break
              case 90:
                  ref[5].classList.add('clicked')
                  break
              case 180:
                  ref[6].classList.add('clicked')
                  break
              case 365:
                  ref[7].classList.add('clicked')
                  break
              case 730:
                  ref[8].classList.add('clicked')
                  break
              default:
                  break
          }
      },
  },
}
